import { useContext } from 'react'
import getOr from 'lodash/fp/getOr'
import { UserContext } from '../contexts/UserProvider'


export function useCompanyId() {
    const { company } = useContext(UserContext)
    return getOr('', 'id', company)
}
